import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { LegalDocument } from '../components/LegalDocument';
import { TERMS_EFFECTIVE_DATE, termsConditions } from '../data/termsConditions';
export function Terms() {
  return <>
      <PageHeader title="Lightning Learn Terms and Conditions" intro={`Effective ${TERMS_EFFECTIVE_DATE}`} data-id="element-466" data-mp="2henulu1k2ge" />
      <LegalDocument blocks={termsConditions} data-id="element-467" data-mp="7bivz8f1mgj2" />
    </>;
}